<template>
  <el-dialog
      title="修改密码"
      :visible.sync="show"
      width="30%"
      @close="onClose"
      :close-on-click-modal="false">
    <div class="column-view">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="用户名" required>
          <el-input placeholder="请输入账户用户名" v-model="userName"></el-input>
        </el-form-item>
        <el-form-item label="原密码" required>
          <el-input placeholder="请输入原密码" v-model="oldPassword" type="password" :show-password="true"></el-input>
        </el-form-item>

        <el-form-item label="新密码" required>
          <el-input placeholder="请输入新密码" v-model="password" type="password" :show-password="true"></el-input>
        </el-form-item>

        <el-form-item label="确认密码" required>
          <el-input placeholder="请再次输入密码" v-model="passwordAgain" type="password" :show-password="true"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <div class="dialog-footer">
        <el-button type="default" @click="handleClose">取消</el-button>
        <el-button type="success" @click="doSave">确认</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import md5 from 'js-md5'
export default {
  name: "ChangePasswordDialog",

  data() {
    return {
      userName:'',
      password:'',
      oldPassword:'',
      passwordAgain:'',
      show: false,
    }
  },

  watch: {

  },

  methods: {

    onClose(){
      this.userName='';
      this.oldPassword="";
      this.password='';
      this.passwordAgain=''
    },

    handleClose() {
      this.show=false;
    },

    doSave() {
      if(!this.userName){
        return this.$commonUtils.showMessage('请输入用户名','error')
      }
      if(!this.oldPassword){
        return this.$commonUtils.showMessage('请输入原密码','error')
      }
      if(!this.password){
        return this.$commonUtils.showMessage("请输入新密码",'error')
      }
      if(this.password.trim().length<6){
        return this.$commonUtils.showMessage("密码长度不少于 6 位",'error')
      }
      if(!this.passwordAgain){
        return this.$commonUtils.showMessage("请再次输入密码",'error')
      }
      if(this.passwordAgain.trim()!==this.password.trim()){
        return this.$commonUtils.showMessage("两次密码不一致",'error')
      }

      //修改密码

      let pass_md5=md5(this.password);
      let old_pass_md5=md5(this.oldPassword);

      this.$prompt('确认修改密码？', '修改密码', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '修改中...'
            this.http.api('restPassword', {name:this.userName,oldPassword:old_pass_md5,password:pass_md5}).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '确认'
                done()
                this.handleClose()
                this.$commonUtils.showMessage('修改成功,请登录','success')
                this.$store.dispatch('user/logout')
                this.$router.push(`/login?redirect=${this.$route.fullPath}`)
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '确认'
              }
            }).catch(() => {})
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })

    },

    showDialog() {
      this.show = true;
    }

    ,
  }

}
</script>

<style scoped>

</style>
